export default __webpack_public_path__ + "static/5-d1187ed9556bdb6c42833eae25969945.gif";